<template>
  <header class="header">
    <nav class="nav">
      <div class="nav-brand">
        <span class="brand-text">{{ $t('nav.brand') }}<span class="text-cyan">WEB</span></span>
      </div>

      <div class="nav-links">
        <a href="#" class="nav-link">{{ $t('nav.dashboard') }}</a>
      </div>

      <div class="nav-actions">
        <div class="user-info">
          <span class="user-name">{{ authStore.username }}</span>
          <span class="user-badge font-mono">{{ authStore.role }}</span>
        </div>

        <LanguageSwitcher />

        <router-link to="/" class="home-btn" :title="$t('nav.home')">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
            <polyline points="9 22 9 12 15 12 15 22"></polyline>
          </svg>
        </router-link>

        <button
          @click="handleLogout"
          class="logout-btn"
          :title="$t('auth.logout.buttonTitle')"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
        </button>
      </div>
    </nav>

    <TokenVerify />
  </header>
</template>

<script>
import { useRouter } from 'vue-router'
import { useAuthStore } from '@/stores'
import TokenVerify from '@/components/TokenVerify.vue'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'

export default {
  components: { TokenVerify, LanguageSwitcher },
  setup() {
    const router = useRouter()
    const authStore = useAuthStore()

    const handleLogout = () => {
      authStore.logout()
      router.push('/')
    }

    return { authStore, handleLogout }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: rgba(15, 15, 15, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 1px solid var(--border-mist-08);
}

.nav {
  max-width: 1400px;
  margin: 0 auto;
  padding: var(--space-4) var(--space-6);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-6);
}

.nav-brand {
  flex-shrink: 0;
}

.brand-text {
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: -0.01em;
}

.nav-links {
  flex: 1;
  display: flex;
  align-items: center;
  gap: var(--space-8);
}

.nav-link {
  font-size: 0.9375rem;
  color: var(--color-ghost-white);
  text-decoration: none;
  transition: color var(--transition-base);
}

.nav-link:hover {
  color: var(--color-cyan);
}

.nav-actions {
  display: flex;
  align-items: center;
  gap: var(--space-4);
}

.user-info {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  padding: var(--space-2) var(--space-4);
  background-color: var(--color-pure-black);
  border: 1px solid var(--border-mist-10);
  border-radius: var(--radius-pill);
}

.user-name {
  font-size: 0.875rem;
  color: var(--color-pure-white);
}

.user-badge {
  font-size: 0.6875rem;
  padding: var(--space-1) var(--space-2);
  background-color: rgba(0, 255, 255, 0.1);
  border: 1px solid rgba(0, 255, 255, 0.2);
  border-radius: var(--radius-sm);
  color: var(--color-cyan);
  letter-spacing: 0.05em;
}

.home-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-ghost-white);
  background: transparent;
  border: 1px solid var(--border-mist-10);
  border-radius: var(--radius-md);
  transition: all var(--transition-base);
  text-decoration: none;
}

.home-btn:hover {
  color: var(--color-cyan);
  border-color: rgba(0, 255, 255, 0.3);
  background-color: rgba(0, 255, 255, 0.1);
}

.logout-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-ghost-white);
  background: transparent;
  border: 1px solid var(--border-mist-10);
  border-radius: var(--radius-md);
  transition: all var(--transition-base);
}

.logout-btn:hover {
  color: #ff6b6b;
  border-color: rgba(255, 107, 107, 0.3);
  background-color: rgba(255, 107, 107, 0.1);
}

/* Responsive */
@media (max-width: 768px) {
  .nav {
    padding: var(--space-3) var(--space-4);
    gap: var(--space-3);
  }

  .nav-links {
    display: none;
  }

  .brand-text {
    font-size: 1rem;
  }

  .user-info {
    padding: var(--space-1) var(--space-3);
    gap: var(--space-2);
  }

  .user-name {
    display: none;
  }

  .nav-actions {
    gap: var(--space-2);
  }

  .home-btn,
  .logout-btn {
    width: 36px;
    height: 36px;
  }
}
</style>
